




































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'Logo',
})
export default class Logo extends Vue {
  @Prop({ default: true })
  dark!: boolean;

  @Prop({ default: true })
  full!: boolean;
}
